import React from "react";
import RootModal from "../../../common/RootModal";
import Button from "../../../common/Button";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../common/New-ToolTip";
import ConfirmationModalNew from "../../../common/ConfirmationModalNew";
import SmokingCessation from "../../../common/tooltip/minor-ailments/smoking-cessation";

const SmokingCessationAlert = ({ open, handleClose, confirmAction }) => {
  return (
    <ConfirmationModalNew
      open={open}
      handleClose={() => handleClose(SmokingCessationAlert.displayName)}
      onCross={() => handleClose(SmokingCessationAlert.displayName)}
      className={`flex flex-col gap-8 max-w-lg w-[445px] bg-gray-20`}
      title="Smoking Cessation Alert"
      headClassName="p-[24px]"
      confirmText="Yes"
      cancelText="No"
      confirmAction={() => {
        confirmAction(SmokingCessationAlert.displayName)
      }}
      content={() => (
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <p>
              Would you like to participate in a Smoking Cessation
              <p className="flex flex-row gap-2">
                Program?
                <ReactSVG
                  src="/icons/information-dark.svg"
                  className="w-5"
                  data-tooltip-id="guideline-update"
                />
                <NewToolTip
                  id="guideline-update"
                  render={() => <SmokingCessation />}
                />
              </p>
            </p>
            <p className="text-teal-600 font-bold">Smoking Cessation Module Coming Soon.</p>
          </div>
        </div>
      )}
    />
  );
};

SmokingCessationAlert.displayName = "SmokingCessationAlert";

export default SmokingCessationAlert;
